export const agGridLocale = {
  fr: {
    // for filter panel
    page: 'Page',
    more: 'Plus',
    to: 'à',
    of: 'de',
    next: 'Suivant',
    last: 'Dernier',
    first: 'Premier',
    previous: 'Précédent',
    loadingOoo: 'Chargement...',

    // for set filter
    selectAll: 'Tout sélectionner',
    searchOoo: 'Chercher...',
    blanks: 'Vides',

    // for number filter and text filter
    filterOoo: 'Filtre...',
    applyFilter: 'Appliquer filtre...',
    equals: 'Est égal',
    notEquals: 'Est différent',

    // for number filter
    lessThan: 'Inférieur à',
    greaterThan: 'Supérieur à',
    lessThanOrEqual: 'Inférieur ou égal à',
    greaterThanOrEqual: 'Supérieur ou égal à',
    inRange: "Dans l'ensemble",

    // for text filter
    contains: 'Contient',
    notContains: 'Ne contient pas',
    startsWith: 'Commence par',
    endsWith: 'Finit par',

    // filter conditions
    andCondition: 'ET',
    orCondition: 'OU',

    // the header of the default group column
    group: 'Groupe',

    // tool panel
    columns: 'Colonnes',
    filters: 'Filtres',
    rowGroupColumns: 'Colonnes Pivot',
    rowGroupColumnsEmptyMessage: 'Placez des colonnes dans le groupe',
    valueColumns: 'Colonnes Valeurs',
    pivotMode: 'Mode Pivot',
    groups: 'Groupes',
    values: 'Valeurs',
    pivots: 'Pivots',
    valueColumnsEmptyMessage: 'Placez des colonnes pour aggréger',
    pivotColumnsEmptyMessage: 'Placez des colonnes pour le pivot',
    toolPanelButton: 'Outils',

    // other
    noRowsToShow: 'Aucune ligne',

    // enterprise menu
    pinColumn: 'Fixer la colonne',
    valueAggregation: "Valeur d'aggrégation",
    autosizeThiscolumn: 'Redimensionner la colonne',
    autosizeAllColumns: 'Redimensionner toutes les colonnes',
    groupBy: 'Grouper par',
    ungroupBy: 'Dégrouper par',
    resetColumns: 'Rétablir les colonnes',
    expandAll: 'Tout développer',
    collapseAll: 'Tout fermer',
    toolPanel: 'Outils',
    export: 'Exporter',
    csvExport: 'Export CSV',
    excelExport: 'Export Excel (.xlsx)',
    excelXmlExport: 'Export Excel (.xml)',

    // enterprise menu pinning
    pinLeft: 'Fixer <<',
    pinRight: 'Fixer >>',
    noPin: 'Libérer <>',

    // enterprise menu aggregation and status bar
    sum: '∑',
    min: 'Min',
    max: 'Max',
    none: 'Aucune',
    count: 'Nb',
    avg: 'Moy',
    average: 'Moyenne',
    filteredRows: 'Filtrées',
    selectedRows: 'Sélectionnées',
    totalRows: 'Nb Lignes',
    totalAndFilteredRows: 'Lignes',

    // standard menu
    copy: 'Copier',
    copyWithHeaders: 'Copier avec en-têtes',
    ctrlC: 'ctrl + C',
    paste: 'Coller',
    ctrlV: 'ctrl + V',
  },
};

export function EurCurrencyCellRenderer(params: any): string {
  if (typeof params.value !== 'number' || isNaN(params.value)) {
    return '';
  }
  const formatter = new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
  });
  const value =
    params.value > -0.005 && params.value < 0.005 ? 0.0 : params.value;
  return formatter.format(value);
}

export function EurCurrencyBracketCellRenderer(params: any): string {
  if (typeof params.value !== 'number' || isNaN(params.value)) {
    return '';
  }
  const formatter = new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
  });
  const value =
    params.value > -0.005 && params.value < 0.005 ? 0.0 : params.value;
  const formattedValue = formatter.format(value);
  return value < 0.0 ? '(' + formattedValue + ')' : formattedValue;
}

export function bracketsFormatter(params): string {
  if (typeof params.value !== 'number' || isNaN(params.value)) {
    return '';
  }
  const value =
    params.value > -0.005 && params.value < 0.005 ? 0.0 : params.value;
  return value < 0.0 ? '(' + value + ')' : value;
}

export function NoDecimalCellRenderer(params: any): string {
  if (typeof params.value !== 'number' || isNaN(params.value)) {
    return '';
  }
  const value = Math.round(params.value);
  return new Intl.NumberFormat('fr-FR').format(value);
}

export function DecimalCellRenderer(params: any): string {
  if (typeof params.value !== 'number' || isNaN(params.value)) {
    return '';
  }
  return new Intl.NumberFormat('fr-FR').format(params.value.toFixed(2));
}

export function PercentageCellRenderer(params: any): string {
  if (typeof params.value !== 'number' || isNaN(params.value)) {
    return '';
  }
  const value = Math.round(params.value);
  return value + '%';
}
export function EuroKCellRenderer(params: any): string {
    if (typeof params.value !== 'number' || isNaN(params.value)) {
        return '';
    }
    const value = Math.round(params.value / 1000);
    return new Intl.NumberFormat('fr-FR').format(value);
}
